import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

    import { TwoFactorAuthenticationApi, Setup2FARequest } from "../../services";

/**
 * @author Atish Bagate
 */
export const useSetup2FA = () => {
  return useMutationWithLoading(async (params: { setup2FARequest: Setup2FARequest, xTENANTID?: string }) => {
    const response = await new TwoFactorAuthenticationApi(getConfigObject()).setup2FA(
        params.setup2FARequest,
        params.xTENANTID
    );
    return response;
  });
};